import React from "react";
import "./../styles/Preloader.css";

export default function Preloader() {
  return (
    <div className="preloader">
      <div className="loader-circle">
        <span className="loader-text">AS</span>
      </div>
    </div>
  );
}
